import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import PrivacyPolicy from '../Components/LegalComponents/PrivacyPolicy'

function Privacy() {
  return (
    <div>
        <Navbar/>
        <PrivacyPolicy/>
        <Footer/>
    </div>
  )
}

export default Privacy